import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';

export const PanelSchema = new GenericModelSchema('panel', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
  },
});
